module.exports = __webpack_public_path__ + "static/media/office-lunch-catering-2.a9f28b01.jpg";